import {ChangeDetectionStrategy, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {CounterService} from './counter.service';
import {PlayableFactoryService} from '../../ui/video-panel/playable-factory.service';
import {Hlsjs} from '../../engine/playable/hlsjs';
import {Subscription} from 'rxjs';

@Component({
  selector: 'gg-counter',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CounterComponent implements OnInit, OnChanges, OnDestroy {
  @Input() channel: string;
  private timer: number;
  private playable: Hlsjs;
  private subscription: Subscription;

  constructor(private counter: CounterService, private playableFactory: PlayableFactoryService) {
  }

  ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log('CounterComponent changes');

    this.counter.channel = this.channel;

    // TODO: wait for init:
    setTimeout(() => {
      this.reportLags();
      this.reportView();
    }, 1000);
  }

  ngOnDestroy(): void {
    clearInterval(this.timer);
    this.playable = null;
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  private reportLags() {
    if (this.playable) {
      this.ngOnDestroy();
    }

    this.playable = this.playableFactory.getCurrentPlayable() as Hlsjs;

    if (this.playable && this.playable.isLive) {
      console.log('isLive! report stalled!', this.playable.stalled$);

      this.timer = setInterval(() => this.reportView(), 60000);
      this.subscription = this.playable.stalled$.subscribe(data => this.reportStalled());
    }
  }

  private reportView() {
    this.counter.sendEvent('viewing_params', {
      server: 'noip',
      server_name: 'newplayer',
      q: ''
    });
  }

  private reportStalled() {
    console.log('CounterComponent reportStalled');

    this.counter.sendEvent('lags', {
      type: 'hlsjs',
      lagver2: 1,
      server: 'noip',
      server_name: 'newplayer',
      q: ''
    });
  }


}
